import React from 'react'

const LoadingSpinner = () => {
    return(
        <div className="d-flex justify-content-center">
            <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
    )
}

export default LoadingSpinner